import type { Period } from '../../utils/periods';

export const SALES_TITLE: Record<Period, string> = {
  today: "Today's Sales",
  yesterday: "Yesterday's Sales",
  wtd: 'WTD Sales',
  mtd: 'MTD Sales',
};

export const SECTION_SUFFIX: Record<Period, string> = {
  today: 'Today',
  yesterday: 'Yesterday',
  wtd: 'WTD',
  mtd: 'MTD',
};
